import { render } from "./PDFgen.vue?vue&type=template&id=a3223a6c&scoped=true"
import script from "./PDFgen.vue?vue&type=script&lang=js"
export * from "./PDFgen.vue?vue&type=script&lang=js"

import "./PDFgen.vue?vue&type=style&index=0&id=a3223a6c&scoped=true&lang=css"

import exportComponent from "/Users/siorikitajima/Dropbox (Personal)/Code/GCV/ga-emc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3223a6c"]])

export default __exports__